import TextNavBackground from "../../components/common/TextNavBackground";
import { apiWrapper } from "../../utils/api/apiWrapper";
import { kPastSeasonListURL } from "../../utils/constants/apiUrls";
import { GUEST_TOKEN } from "../../utils/constants/names";
import { TWELVE_MONTHS_REFRESH_INTERVAL_SECONDS } from "../../utils/constants/numbers";
import { customStaticSeoConfig } from "../../utils/helpers/helpers";
import PastSeasonCard from "../../components/elements/archives/pastSeasonCard";
import { TabNoData } from "../../components/common/NoData";

const ArchiveList = ({ pastSeasons }) => {
  const pastSeasonList = pastSeasons;

  return (
    <>
      {customStaticSeoConfig("Asante Kotoko Archives")}

      <TextNavBackground title={"Archives"} />

      <div className="relative px-6 sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0 py-10 max-w-prose mx-auto">
        {pastSeasonList.length !== 0 ? (
          <>
            <div className="container grid grid-cols-2 gap-6 mx-auto sm:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5">
              {pastSeasonList.map((season) => (
                <PastSeasonCard key={season.slug} season={season} />
              ))}
            </div>
          </>
        ) : (
          <TabNoData />
        )}
      </div>
    </>
  );
};

export default ArchiveList;

export const getStaticProps = async (context) => {
  const token = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const pastSeasons = await apiWrapper.get(kPastSeasonListURL, token);

  return {
    props: {
      pastSeasons: pastSeasons?.data,
    },
    revalidate: TWELVE_MONTHS_REFRESH_INTERVAL_SECONDS,
  };
};
